// extracted by mini-css-extract-plugin
export default {"Page":"AdminLogin_Page__ZUwfI","PageContainer":"AdminLogin_PageContainer__f3u8V","Container":"AdminLogin_Container__Mhlwk","Button":"AdminLogin_Button__JCgbb"};